var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_1113)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 50,
    height: 50,
    rx: 25,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 34.25C37.4834 34.25 38.9334 33.8101 40.1668 32.986C41.4001 32.1619 42.3614 30.9906 42.9291 29.6201C43.4968 28.2497 43.6453 26.7417 43.3559 25.2868C43.0665 23.832 42.3522 22.4956 41.3033 21.4467C40.2544 20.3978 38.918 19.6835 37.4632 19.3941C36.0083 19.1047 34.5003 19.2532 33.1299 19.8209C31.7594 20.3886 30.5881 21.3499 29.764 22.5832C28.9399 23.8166 28.5 25.2666 28.5 26.75C28.502 28.7385 29.2928 30.645 30.6989 32.0511C32.105 33.4572 34.0115 34.248 36 34.25ZM36 21.75C36.9889 21.75 37.9556 22.0432 38.7779 22.5927C39.6001 23.1421 40.241 23.923 40.6194 24.8366C40.9978 25.7502 41.0969 26.7555 40.9039 27.7255C40.711 28.6954 40.2348 29.5863 39.5355 30.2855C38.8363 30.9848 37.9454 31.461 36.9755 31.6539C36.0055 31.8469 35.0002 31.7478 34.0866 31.3694C33.173 30.991 32.3921 30.3501 31.8427 29.5279C31.2932 28.7056 31 27.7389 31 26.75C31 25.4239 31.5268 24.1522 32.4645 23.2145C33.4021 22.2768 34.6739 21.75 36 21.75Z",
    fill: "#0085FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 36.25C33.0173 36.2533 30.1578 37.4396 28.0487 39.5487C25.9396 41.6578 24.7533 44.5173 24.75 47.5C24.75 47.8315 24.8817 48.1495 25.1161 48.3839C25.3505 48.6183 25.6685 48.75 26 48.75C26.3315 48.75 26.6495 48.6183 26.8839 48.3839C27.1183 48.1495 27.25 47.8315 27.25 47.5C27.25 45.1794 28.1719 42.9538 29.8128 41.3128C31.4538 39.6719 33.6794 38.75 36 38.75C38.3206 38.75 40.5462 39.6719 42.1872 41.3128C43.8281 42.9538 44.75 45.1794 44.75 47.5C44.75 47.8315 44.8817 48.1495 45.1161 48.3839C45.3505 48.6183 45.6685 48.75 46 48.75C46.3315 48.75 46.6495 48.6183 46.8839 48.3839C47.1183 48.1495 47.25 47.8315 47.25 47.5C47.2467 44.5173 46.0604 41.6578 43.9513 39.5487C41.8422 37.4396 38.9827 36.2533 36 36.25Z",
    fill: "#0085FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_1113",
    x: 0.6,
    y: 0.6,
    width: 70.8,
    height: 70.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_1113"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_1113",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.b172e21f624df4c6600523a7186be974.svg";
export { ForwardRef as ReactComponent };